'use strict';

const storage = require('./storage-helper');

const { getUrl } = require('./slug-helper');
const { waitOnEvent } = require('./event-helper');
const { checkAnalytics } = require('./analytics-helper');
const { publish } = require('./event-observer');

const BackTabType = 'OnlineCode';

function handleSuccessResponse({ redemption, offerType }) {
  const data = {
    ...redemption,
    isLimited: redemption.isLimitedGlobally || redemption.isLimitedPerUser,
    type: 'REDEEM',
  };

  if (offerType === BackTabType) {
    storage.setItem('@redemption', data);
  }

  publish('REDEMPTION_DATA');

  return data;
}

function handleFailResponse(error) {
  return {
    type: 'ALERT',
    errorCode: error,
    alertMessage: 'GeneralError',
  };
}

function fetchHandler(apiUrl, { isPremiumOffer, offerType }, headers) {
  return window
    .fetch(apiUrl, headers)
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.status);
      }

      return response.json().then(data =>
        handleSuccessResponse({
          redemption: { ...data, isPremiumOffer },
          offerType,
        })
      );
    })
    .catch(error => handleFailResponse(error && error.message));
}

function getRoutes() {
  const { routes } = window.Groupon.Utils.getConfigFromDom();

  return routes;
}

function redemptionHandler({
  offerId,
  referralSource,
  offerType,
  isPremiumOffer,
  merchantName,
}) {
  const routes = getRoutes();
  publish('OFFER_DATA', { offerId, referralSource });

  if (offerType === BackTabType) {
    window.localStorage.removeItem('@redemption');
    storage.setItem('couponRedeemed', true);

    window.open(window.location.href, '_blank');
  }

  return new Promise(resolve =>
    waitOnEvent({
      doneCheck: checkAnalytics(),
      callback: resolve,
      fallback: resolve,
    })
  ).then(clientId => {
    const params = [];

    if (clientId) {
      params.push(`clientId=${clientId}`);
    }

    if (merchantName) {
      params.push(`merchant=${merchantName}`);
    }

    const redemptionUrl = getUrl(
      routes.redemption.main.replace('{offerId}', offerId),
      params
    );

    const { csrfToken } = window.Groupon.Utils.getConfigFromDom();

    const headers = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'csrf-token': csrfToken,
      },
    };

    return fetchHandler(
      redemptionUrl,
      {
        isPremiumOffer,
        offerType,
      },
      headers
    );
  });
}

function redemptionTermsHandler({ offerId, isPremiumOffer }) {
  const routes = getRoutes();
  const termsUrl = routes.redemption.terms.replace('{offerId}', offerId);

  return fetchHandler(termsUrl, { isPremiumOffer });
}

module.exports = {
  redemptionHandler,
  redemptionTermsHandler,
};
